import { Directive, ElementRef, Renderer2, inject } from '@angular/core';
import { BrnSheetClose } from '@spartan-ng/brain/sheet';

@Directive({
	selector: 'button[hlmSheetClose]',
	hostDirectives: [{ directive: BrnSheetClose, inputs: ['delay'] }],
	host: {
		'data-slot': 'sheet-close',
	},
})
export class HlmSheetClose {
	private readonly _element = inject<ElementRef<HTMLButtonElement>>(ElementRef);
	private readonly _renderer = inject(Renderer2);

	constructor() {
		if (!this._element.nativeElement.hasAttribute('type'))
			this._renderer.setAttribute(this._element.nativeElement, 'type', 'button');
	}
}
